import { ReportRecord } from '../../../models/report.model';
import { map } from 'rxjs/operators';
import { digger } from '@cbre/digger';
import { CHINA_SUMMARY_MAPSIZE_ON_RECORDCOUNT } from '../template-blueprints.const';
import { mapAndFormatDynamicValue } from '../utils/dynamic-data-retrievers';

export const CHINA_SUMMARY_COMMON = {
  279: {
    // 279 - Property Name
    displayFn: (record: ReportRecord, _options, ...args) => {
      const values = args.map(arg => mapAndFormatDynamicValue(record, arg));
      return digger(record, 'position') + '. ' + values;
    },
  },
  266: {
    // 266 - Summary Map Base64 Image
    displayFn: (_record: ReportRecord, options) => {
      const { httpClient, reportExportViewService, recordsLength, reportOptions } = options;
      // remove port number from url
      let portNumberIndex: number;
      portNumberIndex = reportExportViewService.baseUrl.lastIndexOf(':');
      const baseURL = reportExportViewService.baseUrl.substring(0, portNumberIndex);
      const uri = '/api/download/miq/export/capture';
      const { expires_in, userInfo, localeId } = localStorage;
      /* appending latlongs for availability only(if exists).
      for property, appending empty string is giving grey image so not appending
       */
      const basePageUrl = `${baseURL}/pdf/map/${options.reportId}?isGroupByProperty=${reportOptions.groupByBuilding}`;
      const includeLatLong = reportOptions.latLong ? `${basePageUrl}&latLong=${reportOptions.latLong}` : basePageUrl;
      const payload = {
        preloadUrl: `${baseURL}/assets/svg/cbre-logo.svg`,
        pageUrl: includeLatLong,
        waitForSelector: ["miq-summary-map[map-state='load']"],
        viewPort:
          recordsLength > CHINA_SUMMARY_MAPSIZE_ON_RECORDCOUNT
            ? { width: 785, height: 569 }
            : { width: 985, height: 569 },
        selector: null,
        localStorageData: { expires_in, userInfo, localeId },
      };
      return httpClient.post(uri, payload).pipe(
        map((data: any) => {
          return `data: image/png;base64,${data}`;
        })
      );
    },
  },
};
